// extracted by mini-css-extract-plugin
export default {"header":"Payrolls_header__gj2Qi","title":"Payrolls_title__aa7Lq"};